const openModalHandler = (e, bodyClass, extraCallback) => {
  try {
    Drupal.behaviors.modalJs.openModal.call(
      e.nativeEvent.target,
      e.nativeEvent,
    );

    if (window && bodyClass) {
      window.document.body.classList.add(bodyClass);
    }

    if (typeof extraCallback === 'function') {
      extraCallback();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      'Looks like Drupal.behaviors.modalJs.openModal is not initialized',
      error,
    );
  }
};

const closeModalHandler = (e, bodyClass, extraCallback) => {
  try {
    Drupal.behaviors.modalJs.closeModal.call(
      e.nativeEvent.target,
      e.nativeEvent,
    );

    if (window && bodyClass) {
      window.document.body.classList.remove(bodyClass);
    }

    if (typeof extraCallback === 'function') {
      extraCallback();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      'Looks like Drupal.behaviors.modalJs.openModal is not initialized',
      error,
    );
  }
};

export { openModalHandler, closeModalHandler };
